import {
  type ApolloClient,
  type NormalizedCacheObject,
} from '@apollo/react-hooks';
import gql from 'graphql-tag';

const UPDATE_COMMENCE_DATE_QUERY = gql`
  mutation ($applicationId: String!, $date: DateTime!) {
    confirmCommencementOfStudy(applicationId: $applicationId, date: $date) {
      applicationId
    }
  }
`;

export const useUpdateConfirmCommenceDate = async (
  client: ApolloClient<NormalizedCacheObject>,
  variables: { applicationId: string; date?: string },
): Promise<any> => {
  const { data } = await client.mutate({
    mutation: UPDATE_COMMENCE_DATE_QUERY,
    variables,
    fetchPolicy: 'no-cache',
  });

  return data.confirmCommencementOfStudy.applicationId;
};
